<template>
  <div id="statsView" :class="hasHeaderBar ? 'has-header' : ''">
    <div class="learners-banner" v-show="$route.name !== 'statFormNew' &&  $route.name !==  'statFormView'">
      <div class="bg-element" v-bind:style="{backgroundImage:'url('+pattern+')'}" >	</div>
      <div class="col s12">
        <h2 class="" style="z-index: 99; position:relative">Court of Appeal Data Capture Forms</h2>
         <p style="font-size: 16.5px;">Technical user guide form for high court judges and masters</p> 
        <button 
          @click="modalInstance.open()"
          class="btn btn-large rounded waves-effect">
          View Instructions
        </button>
      </div>
      </div>
    <div class="row" v-show="$route.name !== 'statFormNew' &&  $route.name !==  'statFormView'">

        <div class="col s12 l10 no-float center-aligned your-entries" v-if="submissions && submissions.length > 0">
        <div class="col s12" >
          <div class="page-title">
            Your Submissions
          </div>
        </div>
        <div class="col s12 m6" v-for="submission in submissions" :key="submission.id">
          <div class="card">
            <div class="card-content">
              <router-link v-if="submission.acf.status === 'new' ||  !submission.acf.status" 
                :to="{name:'statFormView', params:{id:submission.id, userId: user.id, categoryId:submission.categories[0]}}">
              <div class="card-title" v-html="$_categoryName(submission.categories[0])"></div>
              </router-link>
               <div class="card-title" v-else v-html="$_categoryName(submission.categories[0])"></div>
              <span class="badge new" :data-badge-caption="submission.acf.status === 'new' ||  !submission.acf.status ? 'In Progress' : 'Completed'"></span>
              <div v-html="user.name"></div>
              <span v-if="submission.acf.period">{{submission.acf.period.term.replaceAll('0', '')}}</span>
              <div v-if="submission.acf.country">{{submission.acf.country.label}} </div>
            </div>
              <div class="card-action">
               <router-link v-if="submission.acf.status === 'new' ||  !submission.acf.status" 
                :to="{name:'statFormView', params:{id:submission.id, userId: user.id, categoryId:submission.categories[0]}}">
                 <button class="btn">Edit</button>
               </router-link>
                <router-link 
                :to="{name:'statFormView', params:{id:submission.id, userId: user.id, categoryId:submission.categories[0]}, query:{view:'no-edit'}}"
                class="btn" v-else >View Submission</router-link>
             </div>
          </div>
        </div>
      </div>


      <div class="col s12 l10 no-float center-aligned post-entries">
        <div class="col s12">
          <div class="page-title">
            New Forms
          </div>
        </div>
        <div class="col s12 l6" v-for="category in categories" :key="category.id">
           <div class="card">
             <div class="card-content">
                <div class="card-title" v-html="category.name"></div>
                <div class="period_meta" v-if="category.acf.period__term">
                  <div class="p-title" v-html="category.acf.period__term.term.replaceAll('0', '')"></div>
                  <div class="from">
                  {{dateFormat(new Date(category.acf.period__term.date_from), 'dddd DD MMMM, YYYY')}}
                  </div>
                  <div class="to">
                  {{dateFormat(new Date(category.acf.period__term.date_to), 'dddd DD MMMM, YYYY')}}
                  </div>
                </div>
             </div>
             <div class="card-action">
            <!--   <button
              v-if="category.id === 178"
                @click="modalInstance.open()"
                style="margin-right:12px;"
                class="btn white blue-text text-4 rounded waves-effect">
                View Instructions
              </button> -->
        
        <!--         <router-link > -->
                  <button class="btn"
                  @click="createNew(category)">
                    Create New 
                  </button>
              <!--   </router-link> -->
             </div>
           </div>
        </div>
      </div>

    </div>
    <router-view 
    :data-already="alreadySubmited"
    :userProfile="user" 
    @data="$_updateListing"
    :data-categories="categories"/>
    <div class="modal fixed-footer fm" ref="modal">
      <div class="modal-header white">
      <span>Technical user guide</span>
      <button class="btn-flat modal-close right btn-floating waves-effect">
        <i class="material-icons grey-text text-darken-3">close</i>
      </button>
      </div>
      <div class="modal-content">
        <div v-html="userGuide"></div>
      </div>
    </div>
  </div>
</template>
<script>
import equal from 'fast-deep-equal'
import {mapState} from 'vuex'
import pattern from '@/assets/web.svg'
import {userGuide} from './instructions.js'
import {dateFormat, initModal} from '@/functions'
import {getStatsCategories, getMySubmissions} from '@/services/contentService.js'
export default {
  name:'statistics',
  data () {
    return {
      pattern,
      userGuide,
      modalInstance: null,
      modalOptions:{
      },
      ready: false,
      categories: [],
      submissions: [],
    }
  },
  /*  */
  async mounted () {
     this._initModal()
    try {
      let {data} = await getStatsCategories()
      this.categories = data
    } catch (err) {
      window.console.log(err)
    }
    try {
      let {data} = await  getMySubmissions(this.user.id)
      this.submissions = data
      this.ready = true
    } catch (err) {
      window.console.log(err)
    }
  },
  computed : {
    ...mapState({
        user: state => state.user
    }),
    alreadySubmited () {
      return this.submissions.map(({acf, categories}) => {
        return {
          country: acf.country.value,
          category: categories[0],
        }
      })
    },
    hasHeaderBar() {
      return this.$route.name === 'statFormView' || this.$route.name === 'statFormNew'
    },
    currentSubmissionsX:{
      get () {
        return this.submissions.map(x => {
          return {
       /*      category:x.categories[0], */
            period: x.acf.period, 

          }
        })
      }
    },
    currentSubmissions:{
      get () {
        return this.submissions.map(x => {
          return x.categories[0]
        })
      }
    }
  },
  methods:{
     _initModal (){
      this.modalInstance = initModal(this.$refs.modal, this.modalOptions)
    },
    createNew (x) {
      this.$router.push({     
        name:'statFormNew', 
        params:{categoryId:x.id, userId: this.user.id},
        query:{division:x.slug}
                  
      })
    },
    dateFormat,
    canCreate (c, k) {
      window.console.log(k)
      let status = false
        this.currentSubmissionsX.forEach(x => {
        if( equal(c, x.period)) {
          status = true
        }
      })
      return status
    },
    $_categoryName (id) {
      let record = this.categories.find(x => x.id === id)
      return record.name
    },
    $_updateListing (data) {
      let record = this.submissions.findIndex(x => x.id === data.id)
      if(record > -1) this.submissions[record] = data
      else this.submissions.push(data)
    },
  }
}
</script>
<style scoped lang="scss">
#statsView {
  height: calc(100vh - 90px);
  @media screen and (min-width: 980px) {
    width:calc(100% - 300px);
    margin-left: 300px;
  }
  &.has-header {
    padding-top: 76px;
  }
  .page-title {
    margin-top: 12px;
    font-size: 28px;
    margin-bottom: 12px;
  }
  
.modal {
  min-height: 90%;
  top: 5% !important;
  max-width: 768px;
  border-radius: 10px;
}
.modal.fm:not(.datepicker) {
  .modal-header {
    height: 50px;
    font-size: 16px;
    line-height: 34px;
    padding: 8px 16px;
    border-bottom: 1px solid #d9d9d9;
  }
  .modal-content {
    height: calc(100% - 106px) !important;
    }
  }

  .learners-banner {
    background:rgb(250, 250, 250);
    padding: 46px 48px;
    background-size: 50%;
    margin-bottom: 36px;
    background-position: right top;
    background-repeat: no-repeat;
		height: 250px;
		position: relative;
		overflow: hidden;
    @media screen and (max-width:768px) {
      padding: 24px 28px;
    }
    .bg-element {
      position: absolute;
      top:0;
      right:0px;
      height: calc(100% + 64px);
      width:45%;
      background-size: cover !important;
      z-index: 0;
    opacity: .4;
    }
    .user-title {
      font-size:32px;
      margin:12px 0px;
      line-height: 1;
    }
    .short-text {
      p {
        font-size:17px;
        line-height: 1.6; 
        opacity: .9;
        margin:4px 0px 16px;
      }
    }
}

.your-entries {
  margin-top:32px;
  margin-bottom: 64px
}
  .post-entries,  .your-entries {
    display: flex;
    flex-wrap: wrap;
    .col {
      margin-left:0px;
      margin-right: 0px;
      .card {
        border-radius: 10px;
        height: calc(100% - 1.5rem);
        overflow: hidden;
        padding-bottom: 60px;
        .card-action {
          border-top:0px;
          padding-top:0px;
          position: absolute;
          left:0;
          right:0;
          bottom:0;
          button {
            border-radius: 5px;
            min-width: 120px;
          }
        }
      }
    }
  }
}
</style>